<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Goal</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Goals</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="openRatingDialog"
                  ><i class="fa fa-star"></i> Rate your staff</a
                >
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card mb-3">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <button class="btn collapsed">
                          General
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="onSubmit">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button class="btn text-primary float-right mr-3">
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>
                                  Name <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  v-model.trim="$v.title.$model"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': submitted && $v.title.$error
                                  }"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Employee
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="$v.employeeId.$model"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.employeeId.$error
                                  }"
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-10">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model.trim="$v.description.$model"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.description.$error
                                  }"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-2">
                              <div class="form-group">
                                <label>
                                  Goal Category
                                  <span class="text-danger">*</span>
                                </label>
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="$v.categoryId.$model"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.categoryId.$error
                                  }"
                                >
                                  <option disabled value=""
                                    >Select Employee</option
                                  >
                                  <option
                                    v-for="item in categories"
                                    :key="item.id"
                                    :value="item.id"
                                  >
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="form-group">
                                <label>
                                  Start Date <span class="text-danger">*</span>
                                </label>
                                <div class="cal-icon">
                                  <datepicker
                                    calendar-class
                                    input-class
                                    bootstrap-styling
                                    class="datetimepicker"
                                    elevation="15"
                                    type="text"
                                    v-model.trim="$v.startDate.$model"
                                    :class="{
                                      'is-invalid':
                                        submitted && $v.startDate.$error
                                    }"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="form-group">
                                <label>
                                  End Date <span class="text-danger">*</span>
                                </label>
                                <div class="cal-icon">
                                  <datepicker
                                    calendar-class
                                    input-class
                                    bootstrap-styling
                                    class="datetimepicker"
                                    type="text"
                                    v-model.trim="$v.endDate.$model"
                                    :class="{
                                      'is-invalid':
                                        submitted && $v.endDate.$error
                                    }"
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="col-md-2">
                              <div class="form-group">
                                <label>
                                  Percent Complete
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  class="form-control"
                                  v-model.trim="$v.completion.$model"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.completion.$error
                                  }"
                                />
                              </div>
                            </div>
                            <div class="col-md-2" v-if="checkSubjectiveType">
                              <div class="form-group">
                                <label
                                  >Third Rater
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model="thirdrater.employeeId"
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3">
                    <div class="card-header" id="headingTwo">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <button class="btn collapsed">
                          Measurements ({{ goalMeasurements.length }})
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseTwo"
                      class="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogMeasurement"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogMeasurement" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Performance Measurement
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            KPI
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="
                                              goalmeasurement.measurement.kpiId
                                            "
                                            @change="checkKPI($event)"
                                          >
                                            <option disabled>Select KPI</option>
                                            <option
                                              v-for="member in KPIs"
                                              :key="member.id"
                                              :value="member.id"
                                            >
                                              {{ member.title }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Target
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              goalmeasurement.measurement.target
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6" v-if="!type">
                                        <div class="form-group">
                                          <label>
                                            Actual
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="goalmeasurement.actual"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6" v-else>
                                        <div class="form-group">
                                          <label>
                                            Measure by
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="
                                              goalmeasurement.subjectMeasureType
                                            "
                                          >
                                            <option disabled
                                              >Select Option</option
                                            >
                                            <option :value="1"
                                              >Manager Rating</option
                                            >
                                            <option :value="2"
                                              >Employee Rating</option
                                            >
                                            <option :value="4"
                                              >Third Rating</option
                                            >
                                            <option :value="3"
                                              >Average of Rating</option
                                            >
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="dialogEditMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Edit Performance Measurement
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onEditMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            KPI
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="
                                              goalmeasurement.measurement.kpiId
                                            "
                                            disabled
                                          >
                                            <option disabled>Select KPI</option>
                                            <option
                                              v-for="member in KPIs"
                                              :key="member.id"
                                              :value="member.id"
                                            >
                                              {{ member.title }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Target
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              goalmeasurement.measurement.target
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6" v-if="!type">
                                        <div class="form-group">
                                          <label>
                                            Actual
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="goalmeasurement.actual"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6" v-else>
                                        <div class="form-group">
                                          <label>
                                            Measure by
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="
                                              goalmeasurement.subjectMeasureType
                                            "
                                          >
                                            <option disabled
                                              >Select Option</option
                                            >
                                            <option :value="1"
                                              >Manager Rating</option
                                            >
                                            <option :value="2"
                                              >Employee Rating</option
                                            >
                                            <option :value="4"
                                              >Third Rating</option
                                            >
                                            <option :value="3"
                                              >Average of Rating</option
                                            >
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="dialogDeleteMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteMeasurement"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteMeasurement"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersM"
                                :items="goalMeasurements"
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div class="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        @click="openDialogEditMeasurement(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteMeasurement(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>

                  <div class="card mb-3" v-if="this.goalId > 0">
                    <div class="card-header" id="headingFive">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        <button class="btn collapsed">
                          Activity Set
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseFive"
                      class="collapse"
                      aria-labelledby="headingFive"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogActivitySet"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogActivitySet" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Add ActivitySet</h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeActivitySet"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitActivitySet">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Fieldset
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="activitySet.fieldsetId"
                                          >
                                            <option disabled
                                              >Select Fieldset</option
                                            >
                                            <option
                                              v-for="member in fieldSets"
                                              :key="member.id"
                                              :value="member.id"
                                            >
                                              {{ member.name }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Sort
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="activitySet.sort"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Display on Activity Table
                                            <span class="text-danger">*</span>
                                          </label>
                                          <div class="onoffswitch">
                                            <input
                                              type="checkbox"
                                              v-model="activitySet.viewable"
                                              name="onoffswitch"
                                              class="onoffswitch-checkbox"
                                              id="switch_share"
                                            />
                                            <label
                                              class="onoffswitch-label"
                                              for="switch_share"
                                            >
                                              <span
                                                class="onoffswitch-inner"
                                              ></span>
                                              <span
                                                class="onoffswitch-switch"
                                              ></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="dialogEditActivitySet"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Edit Activity Set</h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditActivitySet"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onEditActivitySet">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Field Set
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            class="form-control"
                                            v-model="activitySet.fieldsetId"
                                            disabled
                                          >
                                            <option disabled
                                              >Select Fieldset</option
                                            >
                                            <option
                                              v-for="member in fieldSets"
                                              :key="member.id"
                                              :value="member.id"
                                            >
                                              {{ member.name }}
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Sort
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="activitySet.sort"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Display on Activity Table
                                            <span class="text-danger">*</span>
                                          </label>
                                          <div class="onoffswitch">
                                            <input
                                              type="checkbox"
                                              v-model="activitySet.viewable"
                                              name="onoffswitch"
                                              class="onoffswitch-checkbox"
                                              id="switch_share"
                                            />
                                            <label
                                              class="onoffswitch-label"
                                              for="switch_share"
                                            >
                                              <span
                                                class="onoffswitch-inner"
                                              ></span>
                                              <span
                                                class="onoffswitch-switch"
                                              ></span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="dialogDeleteActivitySet"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteActivitySet"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteActivitySet"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersS"
                                :items="activitySets"
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div class="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        @click="openDialogEditActivitySet(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteActivitySet(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>

                  <div class="card mb-3">
                    <div class="card-header" id="headingThree">
                      <h5
                        class="mb-0 d-flex justify-content-between"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <button class="btn collapsed">
                          Activities ({{ goalActivities.length }})
                        </button>
                        <span class="collapsed">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseThree"
                      class="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row" v-if="this.goalId">
                          <a
                            @click="openDialogActivity"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Activity Modal -->
                        <v-dialog v-model="dialogActivity" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Performance Activity
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeActivity"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div
                                    class="alert alert-danger alert-dismissible fade show"
                                    role="alert"
                                    v-if="error"
                                  >
                                    <strong>Error!</strong> {{ error }}
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="alert"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div
                                    class="alert alert-success alert-dismissible fade show"
                                    role="alert"
                                    v-if="message"
                                  >
                                    <strong>Success!</strong> {{ message }}
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="alert"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <vueDynamicForms
                                v-model="performanceActivity"
                                :title="'Activity Detail'"
                                :form="form"
                                :theme="theme"
                                :button="button"
                                @save="onSubmitActivity"
                              ></vueDynamicForms>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Activity Modal -->

                        <!-- edit Activity Modal -->
                        <v-dialog
                          v-model="dialogEditActivity"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Performance Activity Approval
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditActivity"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-md-12">
                                  <div
                                    class="alert alert-danger alert-dismissible fade show"
                                    role="alert"
                                    v-if="error"
                                  >
                                    <strong>Error!</strong> {{ error }}
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="alert"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div
                                    class="alert alert-success alert-dismissible fade show"
                                    role="alert"
                                    v-if="message"
                                  >
                                    <strong>Success!</strong> {{ message }}
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="alert"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <DynamicValue
                                v-model="performanceActivity"
                                :title="'Activity Detail'"
                                :form="form"
                                :values="performanceActivity"
                              ></DynamicValue>
                              <textarea
                                placeholder="Add your comment"
                                v-model="performanceActivity.comment"
                                class="form-control"
                              >
                              </textarea>
                              <div class="form-group">
                                <label
                                  >Approval
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model="performanceActivity.status"
                                >
                                  <option disabled>Select Approval</option>
                                  <option :value="1">Approve</option>
                                  <option :value="2">Reject</option>
                                </select>
                              </div>
                              <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-3">
                                  <button
                                    @click="onEditActivity"
                                    class="btn btn-success btn-block"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Activity Modal -->

                        <v-dialog
                          v-model="dialogDeleteActivity"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteActivity"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteActivity"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersA"
                                :items="goalActivities"
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.stat`]="{ item }">
                                  <a
                                    class="btn btn-white btn-sm btn-rounded"
                                    v-if="item.status == 0"
                                    aria-expanded="false"
                                  >
                                    <i
                                      class="fa fa-dot-circle-o text-purple"
                                    ></i>
                                    Required Approval
                                  </a>
                                  <a
                                    class="btn btn-white btn-sm btn-rounded"
                                    v-if="item.status == 1"
                                    aria-expanded="false"
                                  >
                                    <i
                                      class="fa fa-dot-circle-o text-success"
                                    ></i>
                                    Approved
                                  </a>
                                  <a
                                    class="btn btn-white btn-sm btn-rounded"
                                    v-if="item.status == 2"
                                    aria-expanded="false"
                                  >
                                    <i
                                      class="fa fa-dot-circle-o text-danger"
                                    ></i>
                                    Rejected
                                  </a>
                                </template>
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div class="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        @click="openDialogEditActivity(item)"
                                        v-if="item.status == 0"
                                        class="dropdown-item"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Approval</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteActivity(item)"
                                        v-if="item.status == 0"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3">
                    <div class="card-header" id="headingFour">
                      <h5
                        class="mb-0 d-flex justify-content-between"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <button class="btn collapsed">
                          Attachments ({{ goalAttachments.length }})
                        </button>
                        <span class="collapsed">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>
                    <div
                      id="collapseFour"
                      class="collapse"
                      aria-labelledby="headingFour"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row" v-if="this.goalId">
                          <a
                            @click="openDialogAttachment"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <table
                                class="table table-striped custom-table mb-0 datatable"
                              >
                                <tbody>
                                  <tr
                                    v-for="item in goalAttachments"
                                    :key="item.id"
                                  >
                                    <td>
                                      <img
                                        alt=""
                                        :src="
                                          generateDocumentImage(item.document)
                                        "
                                        width="30"
                                      />
                                      <td></td>
                                      <td>{{ item.title }}</td>
                                    </td>

                                    <td>
                                      {{
                                        new Date(item.createdAt).toDateString()
                                      }}
                                    </td>
                                    <td class="text-right">
                                      <a
                                        class="dropdown-item"
                                        v-if="item.document"
                                        @click="
                                          getAttachDocument(item.document)
                                        "
                                        ><i class="fa fa-download m-r-5"></i>
                                        Download</a
                                      >
                                    </td>
                                    <td class="text-right">
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteAttachment(item)"
                                        data-toggle="modal"
                                        data-target="#delete_policy"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- Add Attachment Modal -->
                        <v-dialog v-model="dialogAttachment" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">Add Attachment</h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeAttachment"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitAttachment">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label
                                            >Title
                                            <span class="text-danger"
                                              >*</span
                                            ></label
                                          >
                                          <input
                                            v-model="attachmentTitle"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>Upload Policy</label>
                                          <div class="custom-file" v-if="!file">
                                            <input
                                              type="file"
                                              class="custom-file-input"
                                              id="cv_upload"
                                              @change="onFilePicked"
                                            />
                                            <label
                                              class="custom-file-label"
                                              for="cv_upload"
                                              >Choose file</label
                                            >
                                          </div>
                                          <div class="row" v-if="file">
                                            <div class="col-md-6">
                                              <span>{{ fileName }}</span>
                                            </div>
                                            <div class="col-md-6">
                                              <a
                                                class="btn btn-primary"
                                                @click="changeFile"
                                                >Change File</a
                                              >
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Activity Modal -->
                        <v-dialog
                          v-model="dialogDeleteAttachment"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteAttachment"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteAttachment"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
        <rating-modal
          :type="0"
          :id="goalId"
          :dialog="ratingDialog"
          v-if="ratingDialog"
          :method="closeRatingDialog"
        ></rating-modal>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import RatingModal from "@/components/performance/RatingModal.vue";
import vueDynamicForms from "vuejs-dynamic-forms";
import DynamicValue from "@/plugins/dynamicsValue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
    RatingModal,
    vueDynamicForms,
    DynamicValue
  },
  data() {
    return {
      dialog: false,
      goalId: this.$route.params.id,
      dialogMeasurement: false,
      dialogEditMeasurement: false,
      dialogDeleteMeasurement: false,
      dialogActivity: false,
      dialogEditActivity: false,
      dialogDeleteActivity: false,
      dialogActivitySet: false,
      dialogEditActivitySet: false,
      dialogDeleteActivitySet: false,
      dialogAttachment: false,
      dialogDeleteAttachment: false,
      dialogDelete: false,
      ratingDialog: false,
      headersG: [
        {
          text: "Name",
          align: "start",
          value: ""
        },
        { text: "Employee", value: "" },
        { text: "Level", value: "" },
        { text: "Goal Category", value: "" },
        { text: "Start Date", value: "" },
        { text: "End Date", value: "" },
        { text: "Status", value: "" },
        { text: "", value: "actions", sortable: false }
      ],
      headersM: [
        {
          text: "Measurement",
          align: "start",
          value: "measurement.kpi.title"
        },
        { text: "Target", value: "measurement.target" },
        { text: "Actual", value: "actual" },
        { text: "", value: "actions", sortable: false }
      ],
      headersS: [
        {
          text: "Field Name",
          align: "start",
          value: "fieldset.name"
        },
        { text: "Sort", value: "sort" },
        { text: "Viewable", value: "viewable" },
        { text: "", value: "actions", sortable: false }
      ],
      headersA: [],
      performanceActivity: {},
      goalmeasurement: {
        measurement: {}
      },
      unratedMeasurement: null,
      attachment: {},
      activitySet: {},
      goalstatus: 0,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      submitted: false,
      loading: false,
      error: "",
      goalMeasurements: [],
      goalActivities: [],
      goalAttachments: [],
      performanceActivityTypes: [],
      performanceActivitySources: [],
      performanceActivityStatuses: [],
      KPIs: [],
      activitySets: [],
      fieldSets: [],
      categories: [],
      employees: [],
      form: [],
      button: {
        title: "Submit",
        class: "btn btn-primary submit-btn"
      },
      formData: {},
      theme: "light",
      title: "",
      attachmentTitle: "",
      description: "",
      activityDate: null,
      statusId: 0,
      sourceId: 0,
      typeId: 0,
      thirdrater: { employeeId: 0 },
      startDate: null,
      endDate: null,
      categoryId: null,
      employeeId: null,
      completion: 0,
      status: 0,
      file: null,
      fileName: null,
      message: "",
      error: "",
      type: false
    };
  },
  validations: {
    title: { required },
    description: { required },
    startDate: { required },
    endDate: { required },
    categoryId: { required },
    employeeId: { required },
    completion: { required }
  },
  mounted() {
    this.getGoal();
    this.getEmployees();
    this.getGoalCategories();
    this.getPerformanceActivityTypes();
    this.getPerformanceActivitySources();
    this.getPerformanceActivityStatuses();
    this.GetKPIs();

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },

  methods: {
    checkKPI() {
      var index = this.KPIs.findIndex(
        c => c.id == this.goalmeasurement.measurement.kpiId
      );
      var kpi = this.KPIs[index];
      this.type = kpi.measureableFieldset == null;
    },
    checkKPI(event) {
      var index = this.KPIs.findIndex(c => c.id == event.target.value);
      var kpi = this.KPIs[index];
      this.type = kpi.measureableFieldset == null;
    },
    checkSubjectiveType() {
      var index = this.goalMeasurements.filter(
        c => c.measurement.kpi.measureableFieldset == null
      );
      return index.length > 0;
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      this.file = files[0];
    },

    changeFile() {
      this.file = null;
      this.fileName = "";
    },
    getGoal() {
      performanceService.getPerformanceGoal(this.goalId).then(
        model => {
          (this.title = model.title),
            (this.description = model.description),
            (this.startDate = model.startDate),
            (this.endDate = model.endDate),
            (this.categoryId = model.categoryId),
            (this.employeeId = model.employeeId),
            (this.completion = model.completion),
            (this.goalMeasurements = model.goalMeasurements),
            (this.goalActivities = model.goalActivities),
            (this.goalAttachments = model.goalAttachments),
            (this.unratedMeasurement = model.goalMeasurements.find(
              c => c.actual == 0 && c.subjectMeasureType != null
            ));
          if (model.goalThirdRater) {
            this.thirdrater = model.goalThirdRater;
          }
          this.headersA = model.activitySets
            .filter(c => c.viewable)
            .sort((a, b) => a.sort - b.sort)
            .map((item, index) => ({
              text: item.fieldset.name,
              value: item.fieldset.column.toLowerCase(),
              align: index == 0 && "start"
            }));
          this.headersA.push({ text: "", value: "stat", sortable: false });
          this.headersA.push({ text: "", value: "actions", sortable: false });
          this.form = model.activitySets
            .sort((a, b) => a.sort - b.sort)
            .map((item, index) => ({
              name: item.fieldset.name,
              class: "form-control",
              column: item.fieldset.column.toLowerCase(),
              type: this.getControlType(item.fieldset.type, item.fieldset.name)
            }));
          this.goalstatus = model.status;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getControlType(type, name) {
      switch (type) {
        case "string":
          if (name == "Description") {
            return "textarea";
          } else {
            return "text";
          }
        case "date":
          return "date";
        case "double":
          return "text";
        case "bool":
          return "checkbox";
      }
    },
    getEmployees() {
      employeeService.getEmployees(this.company.id).then(
        model => {
          this.employees = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getGoalCategories() {
      performanceService.getGoalCategories(this.company.id).then(
        model => {
          this.categories = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getPerformanceActivityTypes() {
      performanceService.getPerformanceActivityTypes(this.company.id).then(
        model => {
          this.performanceActivityTypes = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getPerformanceActivitySources() {
      performanceService.getPerformanceActivitySources(this.company.id).then(
        model => {
          this.performanceActivitySources = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getPerformanceActivityStatuses() {
      performanceService.getPerformanceActivityStatuses(this.company.id).then(
        model => {
          this.performanceActivityStatuses = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    GetKPIs() {
      performanceService.getKPIs(this.company.id).then(model => {
        this.KPIs = model;
      });
    },
    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      if (this.goalId) {
        performanceService
          .updateGoal(
            this.goalId,
            this.description,
            this.startDate,
            this.endDate,
            this.categoryId,
            this.employeeId,
            this.completion,
            this.title,
            this.thirdrater,
            this.goalstatus
          )
          .then(
            m => {
              this.message = "Goal have been updated successful";
              this.getGoal();
            },
            error => {
              this.error = error;
            }
          );
      } else {
        performanceService
          .addGoal(
            this.description,
            this.startDate,
            this.endDate,
            this.categoryId,
            this.employeeId,
            this.completion,
            this.title,
            this.goalstatus
          )
          .then(
            m => {
              this.goalId = m;
              this.message = "Goal have been created successful";
              this.getGoal();
            },
            error => {
              this.error = error;
            }
          );
      }
    },
    onSubmitMeasurement() {
      this.goalmeasurement.goalId = this.goalId;
      performanceService.addGoalMeasurement(this.goalmeasurement).then(
        model => {
          this.closeMeasurement();
          this.getGoal();
        },
        error => {
          this.error = error;
        }
      );
    },
    onEditMeasurement() {
      performanceService.updateGoalMeasurement(this.goalmeasurement).then(
        model => {
          this.closeEditMeasurement();
          this.getGoal();
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmitActivitySet() {
      this.activitySet.goalId = this.goalId;
      performanceService.addActivitySet(this.activitySet).then(
        model => {
          this.closeActivitySet();
          this.getGoal();
        },
        error => {
          this.error = error;
        }
      );
    },
    onEditActivitySet() {
      performanceService.updateActivitySet(this.activitySet).then(
        model => {
          this.closeEditActivitySet();
          this.getGoal();
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmitAttachment() {
      performanceService
        .addGoalAttachment(
          0,
          this.goalId,
          this.attachmentTitle,
          this.file,
          this.company.id
        )
        .then(
          model => {
            (this.attachmentTitle = ""),
              (this.file = null),
              (this.fileName = "");
            this.closeAttachment();
            this.getGoal();
          },
          error => {
            this.error = error;
          }
        );
    },
    onSubmitActivity() {
      this.performanceActivity.goalId = this.goalId;
      console.log(this.performanceActivity);
      performanceService.addGoalActivity(this.performanceActivity).then(
        model => {
          console.log(`model`, model);
          this.closeActivity();
          this.getGoal();
        },
        error => {
          this.error = error;
        }
      );
    },
    onEditActivity() {
      if (this.performanceActivity.status == 0) {
        alert("please select approval option");
        return;
      }
      performanceService.editGoalActivity(this.performanceActivity).then(
        model => {
          console.log(`model`, model);
          this.closeEditActivity();
          this.getGoal();
        },
        error => {
          console.log(`error`, error);
          this.error = error;
        }
      );
    },
    onDeleteActivity() {
      performanceService
        .removeGoalActivity(this.goalActivity.id)
        .then(model => {
          this.getGoal();
          this.closeDeleteActivity();
        });
    },
    onDeleteMeasurement() {
      performanceService
        .removeGoalMeasurement(this.goalmeasurement.id)
        .then(model => {
          this.getGoal();
          this.closeDeleteMeasurement();
        });
    },
    onDeleteAttachment() {
      performanceService
        .removeGoalAttachment(this.attachment.id)
        .then(model => {
          this.getGoal();
          this.closeDeleteAttachment();
        });
    },
    getAttachDocument(file) {
      organizationService.getPolicyDocument(file).then(
        model => {
          let blob = new Blob([model.data], { type: model.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, model.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = model.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          error = error;
        }
      );
    },
    generateDocumentImage(file) {
      var splitFile = file.split("\\");
      var fileName = splitFile[splitFile.length - 1];
      var contentType = fileName.split(".")[1];
      switch (contentType) {
        case "aspx":
          return require("../../assets/document/asp-file-format.png");
        case "bak":
          return require("../../assets/document/bak-file-format.png");
        case "csv":
          return require("../../assets/document/csv-file-format.png");
        case "xlsx":
          return require("../../assets/document/csv-file-format.png");
        case "docx":
          return require("../../assets/document/doc-file-format.png");
        case "doc":
          return require("../../assets/document/doc-file-format.png");
        case "html":
          return require("../../assets/document/html-file-format.png");
        case "log":
          return require("../../assets/document/log-file-format.png");
        case "ods":
          return require("../../assets/document/ods-file-format.png");
        case "pdf":
          return require("../../assets/document/pdf-file-format.png");
        case "png":
          return require("../../assets/document/png-file-format.png");
        case "zip":
          return require("../../assets/document/zip-file-format.png");
      }
    },
    close() {
      this.dialog = false;
      // this.clearModel();
    },
    closeMeasurement() {
      this.dialogMeasurement = false;
    },
    closeEditMeasurement() {
      this.dialogEditMeasurement = false;
    },
    closeActivity() {
      this.dialogActivity = false;
      // this.clearModel();
    },
    closeEditActivity() {
      this.dialogEditActivity = false;
      // this.clearModel();
    },
    closeAttachment() {
      this.dialogAttachment = false;
      // this.clearModel();
    },
    closeDeleteMeasurement() {
      this.dialogDeleteMeasurement = false;
    },
    closeDeleteActivity() {
      this.dialogDeleteActivity = false;
      // this.clearModel();
    },
    closeActivitySet() {
      this.dialogActivitySet = false;
      // this.clearModel();
    },
    closeEditActivitySet() {
      this.dialogEditActivitySet = false;
      // this.clearModel();
    },
    onDeleteActivitySet() {
      performanceService.removeActivitySet(this.activitySet.id).then(model => {
        this.getGoal();
        this.closeDeleteActivitySet();
      });
    },
    closeDeleteAttachment() {
      this.dialogDeleteAttachment = false;
      // this.clearModel();
    },
    openDialog() {
      this.dialog = true;
    },
    openDialogMeasurement() {
      this.message = "";
      this.error = "";
      this.dialogMeasurement = true;
    },
    openDialogEditMeasurement(item) {
      this.message = "";
      this.error = "";
      console.log(`item`, item);
      this.goalmeasurement = item;
      this.dialogEditMeasurement = true;
    },
    openDeleteMeasurement(item) {
      this.goalmeasurement = item;
      this.dialogDeleteMeasurement = true;
    },
    openDeleteAttachment(item) {
      this.attachment = item;
      this.dialogDeleteAttachment = true;
    },
    openDialogAttachment() {
      this.message = "";
      this.error = "";
      this.dialogAttachment = true;
    },
    openDeleteActivity(item) {
      this.goalActivity = item;
      this.dialogDeleteActivity = true;
    },
    openDeleteActivitySet(item) {
      this.activitySet = item;
      this.dialogDeleteActivitySet = true;
    },
    openDialogActivity() {
      this.message = "";
      this.error = "";
      this.dialogActivity = true;
    },
    openDialogActivitySet() {
      this.message = "";
      this.error = "";
      this.dialogActivitySet = true;
    },
    openRatingDialog() {
      this.ratingDialog = true;
    },
    closeRatingDialog() {
      this.ratingDialog = false;
      this.getGoal();
    },
    closeDeleteActivitySet() {
      this.dialogDeleteActivitySet = false;
      // this.clearModel();
    },
    openDialogEditActivity(item) {
      console.log("edit activity", item);
      this.message = "";
      this.error = "";
      this.performanceActivity = item;
      this.dialogEditActivity = true;
    },
    openDialogEditActivitySet(item) {
      this.message = "";
      this.error = "";
      this.activitySet = item;
      this.dialogEditActivitySet = true;
    }
  },
  name: "goals"
};
</script>
<style scoped>
.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/performance/editGoalByTeam.vue